import { render, staticRenderFns } from "./Interface.vue?vue&type=template&id=4dc1e560&"
import script from "./Interface.vue?vue&type=script&lang=ts&"
export * from "./Interface.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports